export const validateImageFile = (file, sizeLimit, fileTypes) => {
  const allowedTypes = fileTypes;
  if (!allowedTypes.includes(file.type)) {
    return { valid: false, message: 'Please specify a valid image file (.jpg, .jpeg, .gif, or .png).' };
  }
  if (file.size > sizeLimit) {
    return { valid: false, message: `File is too large, maximum file size is ${sizeLimit / 1024 / 1024}MB limit.` };
  }
  return { valid: true };
}
